export default "https://assets.egbcdn.net/assets/packs/_/images/promo_action/instructions/image2-84d739b3f7ca6e71749d3f9de5093c75.png";